import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PlatformInterceptorService implements HttpInterceptor {

    constructor() { }

    /**
     * Adds platform ID (developer-docs/release-notes) header to HTTP request.
     * @param request The outgoing request object to handle.
     * @param next The next interceptor in the chain, or the backend.
     */
    intercept(request: HttpRequest<any>, next: HttpHandler) {
        const modified = request.clone({setHeaders: {'Platform': environment.platformId}});

        return next.handle(modified);
    }
}

